module.exports = {"data":[{"type":"violin","mode":"markers","uid":"91db56","box":{"visible":true},"meanline":{"visible":true},"bandwidth":0,"x":[1,2,3],"xsrc":"x1"}],"layout":{"xaxis":{},"yaxis":{},"autosize":true},"frames":[]}


//////////////////
// WEBPACK FOOTER
// ./dev/percy/violin.json
// module id = 1298
// module chunks = 0